<!-- MODAL Ingreso de documento recibido -->
<div style="overflow-y: auto" mdbModal #agregarDocumentoRecibido="mdb-modal" class="modal fade" id="basicExample"
  tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-fluid" style="width: 90%;" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Agregar documento electrónico recibido
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="agregarDocumentoRecibido.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="filtros-body">
          <form autocomplete="off" [formGroup]="formHeader">
            <div class="row">
              <div class="col" style="max-width: 100px;">
                <div class="md-form">
                  <mdb-select [options]="optionsYear" [filterEnabled]="true" [highlightFirst]="false" placeholder="Año"
                    formControlName="anho" [disabled]="band === 0"></mdb-select>
                  <label>Año</label>
                </div>
              </div>
              <div class="col" style="max-width: 120px;">
                <div class="md-form">
                  <mdb-select [options]="optionsMonth" [filterEnabled]="true" [highlightFirst]="false" placeholder="Mes"
                    formControlName="mes" [disabled]="band === 0"></mdb-select>
                  <label>Mes</label>
                </div>
              </div>
              <div class="col" style="max-width: 150px;">
                <div class="md-form">
                  <input disabled value="" type="text" class="form-control" placeholder="" required
                    formControlName="rutProveedor" formatRut #rutEmisor />
                  <label for="rutproveedor">RUT Emisor</label>
                </div>
              </div>
              <div class="col" style="max-width: 300px">

                <h6 class="text-info" *ngIf="proveedorSeleccionado" style="display: contents;">
                  {{ proveedorSeleccionado.nombre }}
                </h6>
              </div>

              <div class="col" style="max-width: 300px">
                <div class="md-form">
                  <input disabled value="" type="text" id="direccion" class="form-control" formControlName="direccion"
                    placeholder="Dirección" required #direccion />
                  <label for="direccion">Dirección</label>
                </div>
              </div>
              <div class="col" style="max-width: 200px">
                <div class="md-form">
                  <mdb-select formControlName="tipoDocumento" [disabled]="true" label="Tipo de documento"
                    [options]="optionsTipoDocumento" placeholder="Seleccionar tipo de documento" [filterEnabled]="true">
                  </mdb-select>
                </div>
              </div>
              <div class="col" style="max-width: 200px">
                <div class="md-form">
                  <mdb-select label="Bodega" formControlName="tipoBodega" [options]="optionsBodega"
                    placeholder="Seleccionar Bodega" [filterEnabled]="true" [disabled]="band === 0">
                  </mdb-select>
                </div>
              </div>

              <div class="col">
                <mdb-checkbox [checked]="true" formControlName="GMovStock" [disabled]="band === 0">Mueve stock
                </mdb-checkbox>
                <mdb-checkbox [checked]="true" formControlName="GMovCtaCte" hidden>Mueve Cta. Corriente
                </mdb-checkbox>
              </div>


            </div>

            <div class="row">
              <div class="col" style="max-width: 200px;">
                <div class="md-form">
                  <input disabled value="" formControlName="DescGlb" type="text" id="rutEmisor" class="form-control"
                    placeholder="" #rutEmisor monto />
                  <label for="rutEmisor">Descuento Gbl.</label>
                </div>
              </div>
              <div class="col" style="max-width: 200px;">
                <div class="md-form">
                  <mdb-date-picker #datePickerFechaDoc [inline]="true" name="fechaDoc" [placeholder]="'Fecha Venc.'"
                    required formControlName="fechaEmision" [disabled]="true">
                  </mdb-date-picker>
                  <label for="fechaDoc">Fecha emisíon</label>
                </div>
              </div>
              <div class="col" style="max-width: 200px; display: none;">
                <div class="md-form">
                  <input disabled value="" type="text" id="IDdoc" class="form-control" placeholder="" #IDdoc required
                    formControlName="IdDoc" />
                  <label for="IDdoc">ID Doc.</label>
                </div>
              </div>
              <div class="col" style="max-width: 200px;display: none;">
                <div class="md-form">
                  <input value="" disabled type="text" id="IdXML" class="form-control" placeholder="" #IdXML
                    formControlName="IdXML" />
                  <label for="IdXML">Folio</label>
                </div>
              </div>
              <div class="col" style="max-width: 200px;">
                <div class="md-form">
                  <input value="" disabled type="text" id="folio" class="form-control" placeholder="" #folio
                    formControlName="folio" />
                  <label for="folio">Folio</label>
                </div>
              </div>
              <div class="col" style="max-width: 200px;">
                <div class="md-form">
                  <input value="" disabled formControlName="RecargoGbl" type="text" id="RGbl" class="form-control"
                    placeholder="" #rutEmisor />
                  <label for="RGbl">Recargo Gbl.</label>
                </div>
              </div>
              <div class="col" style="max-width: 200px;">
                <div class="md-form">
                  <mdb-date-picker #datePickerFechaVencimiento [inline]="true" name="fechaVenc"
                    [placeholder]="'Fecha Venc.'" required formControlName="fechaVencimiento" [disabled]="true">
                  </mdb-date-picker>
                  <label for="FechaVenc.">Fecha Vencimiento</label>
                </div>
              </div>

            </div>


          </form>




          <div class="row p-3">
            <div class="table-responsive">


              <table class="table table-striped table-hover table-sm align-middle">
                <thead class="grey lighten-2">
                  <tr>
                    <th scope="col">Cod. Producto</th>
                    <th scope="col">Descripción</th>
                    <th scope="col">Formato</th>
                    <th scope="col">Cantidad</th>
                    <th scope="col">Precio</th>
                    <th scope="col">Descuento</th>
                    <th scope="col">Recargo</th>
                    <th scope="col">Total</th>
                    <th scope="col">Mueve inv.</th>
                    <th *ngIf=" disabledImport === true" scope="col">Equivalencia</th>
                    <!-- <th *ngIf=" disabledImport === true" scope="col">Product. Valido</th> -->
                    <th scope="col">Cod. ERP</th>
                    <th scope="col">Desc. ERP</th>
                    <th scope="col">Formato ERP</th>
                    <th scope="col">Precio ERP</th>
                    <th scope="col">Total Doc. ERP</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let product of listaDoc">
                    <td>{{product.sku}}</td>
                    <td>{{product.descripcion_producto}}</td>
                    <td>{{product.formato_codigo}}</td>
                    <td>{{product.cantidad}}</td>
                    <td>{{product.precio_unitario | numerico}}</td>
                    <td>{{product.aplicacion_descuento | numerico}}</td>
                    <td>{{product.aplicacion_recargo | numerico}}</td>
                    <td>{{product.monto_total | numerico}}</td>
                    <td class="d-flex justify-content-center">
                      <mdb-checkbox *ngIf="product.producto_valido"
                        [id]="product.additionalInfo.index"
                        [(ngModel)]="product.mov_inv_detalle"
                        [disabled]="band === 0"
                        (change)="changeShowHideButton(product.additionalInfo, $event)">
                      </mdb-checkbox>
                    </td>
                    <td *ngIf="disabledImport === true" style="text-align-last: center;">
                      <span
                        *ngIf="product.sku > 0 && product.equivalencia_producto_id === 0 && product.additionalInfo.checked === true">
                        <button type="button" class="btn btn-secondary d-block btn-sm waves-light" data-dismiss="modal"
                          mdbWavesEffect [disabled]="band === 0" (click)="showAddEquivalencia(product)">Agregar Equivalencia</button>
                      </span>
                      <!-- BOTON PARA QUITAR EQUIVALENCIA -->
                      <!-- <span
                        *ngIf="product.sku > 0 && product.equivalencia_producto_id > 0">
                        <button type="button" class="btn btn-secondary d-block btn-sm waves-light" data-dismiss="modal"
                          mdbWavesEffect [disabled]="band === 0" (click)="showRemoveEquivalencia(product)">Quitar Equivalencia</button>
                      </span> -->
                      <!-- <span
                        *ngIf="product.sku > 0 && product.equivalencia_producto_id > 0 && product.additionalInfo.checked === true">
                        {{product.equivalencia_producto_id}}
                      </span> -->
                      <span *ngIf="product.sku === '' && product.equivalencia_producto_id === 0 ">
                        YA TENGO EQUIVALENCIA?
                      </span>

                    </td>
                    <!-- <td style="padding-left:3%;" *ngIf="disabledImport === true">
                      <span *ngIf="product.sku > 0 && product.equivalencia_producto_id === 0 ">
                        <mdb-checkbox [checked]="product.producto_valido"
                          (change)="changeShowHideButton(product.additionalInfo, $event)"></mdb-checkbox>
                      </span>
                      <span *ngIf="product.equivalencia_producto_id > 0 && product.sku > 0">
                        <mdb-checkbox onclick="return false" [checked]="product.producto_valido"></mdb-checkbox>
                      </span>
                      <span *ngIf="product.sku === ''">
                        <mdb-checkbox onclick="return false" [checked]="false"></mdb-checkbox>
                      </span>
                    </td> -->
                    <td>{{product.sku_erp}}</td>
                    <td>{{product.descripcion_erp}}</td>
                    <td>{{product.formato_nombre}}</td>
                    <td>{{product.precio_erp | numerico}}</td>
                    <td>{{product.total_erp | numerico}}</td>
                  </tr>

                </tbody>
              </table>


            </div>
            <table class="table table-striped table-hover table-sm align-middle">
              <tbody class="blue lighten-5 mt-5">
                <tr>
                  <td align="right"><strong>Monto neto</strong></td>
                  <td align="right"><strong>Monto Exento</strong></td>
                  <td align="right"><strong>Monto IVA</strong></td>
                  <td align="right"><strong>Otros Impuestos</strong></td>
                  <td align="right"><strong>Monto total</strong></td>
                </tr>
              </tbody>
              <tbody class="blue lighten-5 mt-5">
                <tr>
                  <td align="right">$ {{montoNetoT | numerico}}</td>
                  <td align="right">$ {{montoExento | numerico}}</td>
                  <td align="right">$ {{montoIva | numerico}}</td>
                  <td align="right"></td>
                  <td align="right">$ {{montoTotal | numerico}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-default waves-light" data-dismiss="modal"
          (click)="cerrarDocumentoRecibido()" mdbWavesEffect>
          Cerrar
        </button>
        <div class="d-flex align-items-center">
          <div class="mr-3" style="max-width: 200px;" *ngIf="band === 0">
            <div class="md-form">
              <mdb-date-picker #datePickerFechaRecepcion [inline]="true" name="fechaRecepcion"
                [placeholder]="'Fecha Recep.'" required [(ngModel)]="fechaRecepcionValue"
                (ngModelChange)="onFechaRecepcionChange($event)" [disabled]="band === 0">
              </mdb-date-picker>
              <label for="fechaRecepcion">Fecha de Importación</label>
            </div>
          </div>
          <button type="button" class="btn btn-secondary waves-light" mdbWavesEffect (click)="ImportToERP()"
            [disabled]="band === 0 || processing">
            <div *ngIf="processing" class="spinner-border spinner-border-sm" style="margin-right: 5px;" role="status">
            </div>
            Importar al ERP
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- MODAL equivalenciasModal -->
<app-modal-add-edit-equivalencia (onSuccess)="updateListaDoc($event)">
</app-modal-add-edit-equivalencia>

<!-- MODAL seleccionarProveedor -->
<app-modal-seleccionar-proveedor [multiple]="false" (onSelect)="onProveedorSeleccionado($event)" queryType="ONLY_RUT"
  showInfoProveedorInactivoBloqueado="true" (onNotFound)="onProveedorNoEncontrado()">
</app-modal-seleccionar-proveedor>
